<div class="kpi-tooltip-container">
  <p class="kpi-tooltip-description">{{ tooltipContents.description }}</p>
  <div *ngIf="tooltipContents.keyMilestones as keyMilestones">
    <div *ngFor="let keyMilestone of keyMilestones" class="kpi-tooltip-list-item">
      <span class="kpi-tooltip-list-item-bullet">• </span>
      <span class="kpi-tooltip-list-item-label">{{ keyMilestone | sentenceCase }}</span>
    </div>
  </div>

  <p class="kpi-tooltip-thresholds-title">Thresholds:</p>
  <div
    *ngIf="tooltipContents.thresholds as thresholds; else noThresholds"
    class="kpi-tooltip-thresholds-list"
  >
    <div *ngFor="let threshold of thresholds" class="kpi-tooltip-list-item">
      <span class="kpi-tooltip-list-item-bullet">• </span>
      <span class="kpi-tooltip-list-item-label">{{ threshold }}</span>
    </div>
  </div>
  <ng-template #noThresholds>
    <span class="kpi-tooltip-no-thresholds">No thresholds defined</span>
  </ng-template>
</div>
